import React from 'react';

import {
  Button,
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
  DialogTitleProps,
  Typography,
  TypographyProps,
  DialogContentProps,
  DialogActionsProps,
  Box,
} from '@material-ui/core';

import { CustomButton, PersonalColorOptions } from 'components/CustomButton';
import { TypographyCN } from 'components/TypographyCN';
import { theme } from 'styles';
import { useMobile } from 'utils/useMobile';

export type Props = {
  mainTitle?: string;
  withLeftTarget?: PersonalColorOptions;
  mainTitleProps?: TypographyProps;
  title?: string;
  content?: string | React.ReactNode;
  open?: boolean;
  loading?: boolean;
  onClose?: () => void;
  cancelLabel?: string;
  onCancel?: () => void;
  confirmLabel?: string;
  typography?: boolean;
  typographyProps?: TypographyProps;
  typographyCont?: string;
  DialogContentProps?: DialogContentProps;
  DialogActionsProps?: DialogActionsProps;
  Titleprops?: DialogTitleProps;
  onConfirm?: () => void;
  cancelButtonProps?: React.ComponentProps<typeof CustomButton>;
  confirmButtonProps?: React.ComponentProps<typeof CustomButton>;
} & React.ComponentPropsWithoutRef<typeof MuiDialog>;

/* eslint-disable */
export function Dialog({
  mainTitle,
  mainTitleProps,
  title,
  typographyCont,
  open,
  loading,
  onClose,
  cancelLabel,
  confirmLabel,
  Titleprops,
  onCancel,
  typography,
  DialogActionsProps,
  children,
  content,
  typographyProps,
  DialogContentProps,
  onConfirm,
  cancelButtonProps,
  confirmButtonProps,
  withLeftTarget,
  ...rest
}: Props) {
  const isMobile = useMobile();
  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      PaperProps={{ style: { borderRadius: '2rem' } }}
      id="personal-dialog"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      {...rest}
      style={{ width: '100%', height: '100%' }}
    >
      {withLeftTarget && (
        <Box
          style={{
            position: 'absolute',
            width: isMobile ? '10px' : '20px',
            minHeight: '100%',
            backgroundColor: theme.palette?.[withLeftTarget]?.dark,
          }}
        />
      )}
      {/* isMobile ? "100%" : "36rem" */}
      <Box
        style={{
          padding: '2rem',
          paddingLeft: isMobile ? 0 : '2rem',
          paddingRight: isMobile ? 0 : '2rem',
          minWidth: isMobile ? '100%' : '36rem',
        }}
      >
        {mainTitle && (
          <DialogTitle style={{ paddingBottom: 0, textAlign: isMobile ? "center" : undefined }}>
            <TypographyCN 
              fontSize={2} 
              style={{
                fontFamily: "Proxima Nova",
                fontSize: isMobile ? 20 : 32,
                lineHeight: isMobile ? "24px" : "36px",
                // textAlign: isMobile ? "center" : undefined,
              }}
              {...mainTitleProps}>
              {mainTitle}
            </TypographyCN>
          </DialogTitle>
        )}
        {/* <DialogTitle {...Titleprops} disableTypography={!!typography} id="alert-dialog-title">
          {typography ? (
            <Typography {...typographyProps}>{content}</Typography>
          ) : (
            title || 'Você tem certeza que deseja excluir?'
          )}
        </DialogTitle> */}
        <DialogContent 
          style={{
            fontSize: 18,
            fontFamily: 'Roboto',
            fontWeight: 400,
            color: theme.palette.typographyColor,
            marginLeft: isMobile ? 10 : undefined,
            textAlign: isMobile ? "center" : undefined,
            // alignItems: "center",
            paddingTop: 20,
            paddingBottom: 20,
          }}
          {...DialogContentProps}
        >
          {children || content || typography && (
            <DialogContentText id="alert-dialog-description">Está ação não poderá ser desfeita.</DialogContentText>
          )}
        </DialogContent>
        <DialogActions {...DialogActionsProps}>
          {!loading && (
            <Box 
              px={isMobile ? 0 : 2} 
              flex={1} 
              display={'flex'} 
              style={{ 
                width: "100%",
                justifyContent: "center",
                paddingLeft: isMobile ? "10%" : undefined, 
                paddingRight: isMobile ? "10%" : undefined, 
                gap: isMobile ? 10 : 20 
              }}>
              <CustomButton
                variant="outlined"
                color="primary"
                text={cancelLabel || 'CANCELAR'}
                onClick={onCancel}
                autoFocus
                style={{
                  maxWidth: isMobile ? "45%" : undefined
                }}
                {...cancelButtonProps}
              />
              <CustomButton
                color={confirmLabel ? 'primary' : 'secondary'}
                text={confirmLabel || 'EXCLUIR'}
                onClick={onConfirm}
                autoFocus
                style={{
                  maxWidth: isMobile ? "45%" : undefined
                }}
                // style={{ marginLeft: isMobile ? '0.5rem' : '2rem' }}
                {...confirmButtonProps}
              />
            </Box>
          )}
          {loading && (
            <CircularProgress
              size={24}
              css={`
                position: 'absolute';
                top: '50%';
                left: '50%';
                margin-top: -12;
                margin-left: -12;
              `}
            />
          )}
        </DialogActions>
      </Box>
    </MuiDialog>
  );
}
